import { PATHS } from '@/constants/Paths';
import LoginPage from '@/pages/auth/LoginPage';
import DashboardPage from '@/pages/home/DashboardPage';
import ProfilePage from '@/pages/home/ProfilePage';
import CreateSuppliersPage from '@/pages/home/suppliers/CreateSupplierPage';
import ListSuppliersPage from '@/pages/home/suppliers/ListSuppliersPage';
import { createBrowserRouter, Navigate } from 'react-router';
import ProtectedRouter from './ProtectedRouter';
import ViewSupplierPage from '@/pages/home/suppliers/ViewSupplierPage';
import ListBenefitsPage from '@/pages/home/benefits/ListBenefitsPage';
import CreateActivityPage from '@/pages/home/benefits/activity/CreateActivityPage';
import CreateMealPage from '@/pages/home/benefits/activity/CreateMealPage';
import CreateTransferPage from '@/pages/home/benefits/activity/CreateTransferPage';
import ViewActivityPage from '@/pages/home/benefits/activity/ViewActivityPage';
import CreateVehicleWithChauffeurPage from '@/pages/home/benefits/vehicleWithChauffeur/CreateVehicleWithChauffeurPage';
import ViewVehicleWithChauffeurPage from '@/pages/home/benefits/vehicleWithChauffeur/ViewVehicleWithChauffeurPage';
import CreateCarRentalPage from '@/pages/home/benefits/carRental/CreateCarRentalPage';
import ViewCarRentalPage from '@/pages/home/benefits/carRental/ViewCarRentalPage';
import CreateFlightPage from '@/pages/home/benefits/flight/CreateFlightPage';
import ViewFlightPage from '@/pages/home/benefits/flight/ViewFlightPage';
import CreateHotelPage from '@/pages/home/benefits/hotel/CreateHotelPage';
import ViewHotelPage from '@/pages/home/benefits/hotel/ViewHotelPage';
import ListCircuitsPage from '@/pages/home/circuits/ListCircuitsPage';
import TrashPage from '@/pages/home/trash/TrashPage';
import CreateCircuitPage from '@/pages/home/circuits/CreateCircuitPage';
import ViewCircuitPage from '@/pages/home/circuits/ViewCircuitPage';
import RegisterPage from '@/pages/auth/RegisterPage';
import ProfileSelectorRoutePage from '@/pages/auth/ProfileSelectorRoutePage';
import DistributorDashboardPage from '@/pages/distributor/DashboardPage';
import CircuitsPage from '@/pages/distributor/CircuitsPage';
import EstimatesPage from '@/pages/distributor/EstimatesPage';
import ReceiversPage from '@/pages/distributor/ReceiversPage';
import DistributorsPage from '@/pages/home/distributors/DistributorsPage';
import AddDistributorsPage from '@/pages/home/distributors/AddDistributorsPage';
import CircuitDetailsPage from '@/pages/distributor/circuits/CircuitDetailsPage';
import ClientsPage from '@/pages/distributor/ClientsPage';
import CreateClientPage from '@/pages/distributor/clients/CreateClientPage';
import ViewClientPage from '@/pages/distributor/clients/ViewClientPage';
import ListEstimatesPage from '@/pages/distributor/clients/estimates/ListEstimatesPage';
import ViewEstimatePage from '@/pages/distributor/clients/estimates/ViewEstimatePage';
import ReservationRequestsPage from '@/pages/home/reservations/ReservationRequestsPage';
import ViewReservationRequestPage from '@/pages/home/reservations/ViewReservationRequestPage';
import ViewProtectedEstimatePage from '@/pages/protected/ViewProtectedEstimatePage';
import ReceiverStatsPage from '@/pages/home/stats/ReceiverStatsPage';
import DistributorStatsPage from '@/pages/distributor/stats/DistributorStatsPage';
import AdminStatsPage from '@/pages/admin/AdminStatsPage';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminReceiversPage from '@/pages/admin/AdminReceiversPage';
import AdminDistributorsPage from '@/pages/admin/AdminDistributorsPage';
import ErrorPage from '@/components/ErrorPage';
import EditableCircuitDetailsPage from '@/pages/distributor/circuits/EditableCircuitDetailsPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <ProtectedRouter />,
    children: [
      {
        path: PATHS.profile,
        element: <ProfilePage />,
      },
      {
        path: '/receivers',
        errorElement: <ErrorPage />,
        children: [
          {
            index: true,
            path: PATHS.home.dashboard,
            element: <DashboardPage />,
          },
          {
            path: '',
            element: <Navigate to={PATHS.home.dashboard} />,
          },
          {
            path: PATHS.home.suppliers.list,
            element: <ListSuppliersPage />,
          },
          {
            path: PATHS.home.suppliers.create,
            element: <CreateSuppliersPage />,
          },
          {
            path: PATHS.home.suppliers.view,
            element: <ViewSupplierPage />,
          },
          {
            path: PATHS.home.benefits.list,
            element: <ListBenefitsPage />,
          },
          {
            path: PATHS.home.benefits.activity.create,
            element: <CreateActivityPage />,
          },
          {
            path: PATHS.home.benefits.meal.create,
            element: <CreateMealPage />,
          },
          {
            path: PATHS.home.benefits.transfer.create,
            element: <CreateTransferPage />,
          },
          {
            path: PATHS.home.benefits.activity.view,
            element: <ViewActivityPage />,
          },
          {
            path: PATHS.home.benefits.vehicleWithChauffeur.create,
            element: <CreateVehicleWithChauffeurPage />,
          },
          {
            path: PATHS.home.benefits.vehicleWithChauffeur.view,
            element: <ViewVehicleWithChauffeurPage />,
          },
          {
            path: PATHS.home.benefits.carRental.create,
            element: <CreateCarRentalPage />,
          },
          {
            path: PATHS.home.benefits.carRental.view,
            element: <ViewCarRentalPage />,
          },
          {
            path: PATHS.home.benefits.flight.create,
            element: <CreateFlightPage />,
          },
          {
            path: PATHS.home.benefits.flight.view,
            element: <ViewFlightPage />,
          },
          {
            path: PATHS.home.benefits.hotel.create,
            element: <CreateHotelPage />,
          },
          {
            path: PATHS.home.benefits.hotel.view,
            element: <ViewHotelPage />,
          },
          {
            path: PATHS.home.circuits.list,
            element: <ListCircuitsPage />,
          },
          {
            path: PATHS.home.circuits.create,
            element: <CreateCircuitPage />,
          },
          {
            path: PATHS.home.circuits.view,
            element: <ViewCircuitPage />,
          },
          {
            path: PATHS.home.trash,
            element: <TrashPage />,
          },
          {
            path: PATHS.home.distributors.list,
            element: <DistributorsPage />,
          },
          {
            path: PATHS.home.distributors.add,
            element: <AddDistributorsPage />,
          },
          {
            path: PATHS.home.reservations.requests.list,
            element: <ReservationRequestsPage />,
          },
          {
            path: PATHS.home.reservations.requests.view,
            element: <ViewReservationRequestPage />,
          },
          {
            path: PATHS.home.stats.list,
            element: <ReceiverStatsPage />,
          },
        ],
      },
      {
        path: '/distributors',
        errorElement: <ErrorPage />,
        children: [
          {
            index: true,
            path: PATHS.distributors.dashboard,
            element: <DistributorDashboardPage />,
          },
          {
            path: PATHS.distributors.circuits.list,
            element: <CircuitsPage />,
          },
          {
            path: PATHS.distributors.circuits.details,
            element: <CircuitDetailsPage />,
          },
          {
            path: PATHS.distributors.circuits.editableDetails,
            element: <EditableCircuitDetailsPage />,
          },
          {
            path: PATHS.distributors.estimates.list,
            element: <EstimatesPage />,
          },
          {
            path: PATHS.distributors.estimates.view,
            element: <ViewEstimatePage source="allEstimates" />,
          },
          {
            path: PATHS.distributors.receivers.list,
            element: <ReceiversPage />,
          },
          {
            path: PATHS.distributors.clients.list,
            element: <ClientsPage />,
          },
          {
            path: PATHS.distributors.clients.create,
            element: <CreateClientPage />,
          },
          {
            path: PATHS.distributors.clients.view,
            element: <ViewClientPage />,
          },
          {
            path: PATHS.distributors.clients.estimates.list,
            element: <ListEstimatesPage />,
          },
          {
            path: PATHS.distributors.clients.estimates.view,
            element: <ViewEstimatePage />,
          },
          {
            path: PATHS.distributors.stats.list,
            element: <DistributorStatsPage />,
          },
        ],
      },
      {
        path: '/admin',
        errorElement: <ErrorPage />,
        children: [
          {
            index: true,
            path: PATHS.admin.dashboard,
            element: <AdminDashboard />,
          },
          {
            path: PATHS.admin.stats,
            element: <AdminStatsPage />,
          },
          {
            path: PATHS.admin.receivers,
            element: <AdminReceiversPage />,
          },
          {
            path: PATHS.admin.distributors,
            element: <AdminDistributorsPage />,
          },
        ],
      },
    ],
  },
  {
    path: PATHS.auth.login,
    element: <LoginPage />,
  },
  {
    path: PATHS.auth.register,
    element: <RegisterPage />,
  },
  {
    path: PATHS.auth.selectProfile,
    element: <ProfileSelectorRoutePage />,
  },
  { path: PATHS.protected.estimate, element: <ViewProtectedEstimatePage /> },
]);
